import React from "react";
import ReactDOM from "react-dom";
import "whatwg-fetch"; // required until cypress supports fetch API. https://github.com/cypress-io/cypress/issues/95
import "normalize.css"; // Import before any custom CSS. Smoothes out browser differences.
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import "./index.scss";

import { store } from "./store";

import AuthCallback from "./containers/AuthCallback/AuthCallback";
import PageNotFound from "./components/PageNotFound";
import ScreenCloudReactApp from "./ScreenCloudReactApp";
import Setup from "./containers/Setup/Setup";
import Player from "./containers/Player/Player";
import PrivateRoute from "./PrivateRoute";
import View from "./containers/View/View";
import Login from "./containers/Login/Login";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/editor">
          <ScreenCloudReactApp>
            {(sc) => (
              <Switch>
                <Route path="/editor/setup">
                  <Setup sc={sc} />
                </Route>
              </Switch>
            )}
          </ScreenCloudReactApp>
        </Route>

        <Route exact path="/player">
          <ScreenCloudReactApp>
            {(sc) => <Player sc={sc} />}
          </ScreenCloudReactApp>
        </Route>

        <Route path="/callback" component={AuthCallback} />
        <Switch>
          <Route path="/login" component={Login} />
          <PrivateRoute
            path="/view/:orgId/:spaceId/:channelId"
            component={View}
          />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
